import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import img from "../Images/Jayraj_logo.png"
import "../Styles/TourOverview.css";
import "../Styles/PackageTourDetails.css";
import {
    FaCalendarAlt,
    FaClock,
    FaChevronDown,
    FaChevronUp,
} from "react-icons/fa";
import Navber from "./Navber";
import Building from "../Images/Building.png";
import Van from "../Images/Van.png";
import Cablecar from "../Images/CableCar.png";
import NavigationArrow from "../Images/NavigationArrow.png";
import Travelers_favorite from "./Travelers_favorite";
import User_Destinations from "./User_Destinations";
import Typemsg from "./Typemsg";
import Why_travel_with_us from "./Why_travel_with_us";
import api from "../Api.js";
import Slider from "react-slick";
import DOMPurify from "dompurify";
import SafeMap from "./Safemap.jsx";
import { FormControl, InputLabel, Select } from '@mui/material'
import {
    Modal,
    Backdrop,
    Fade,
    Box,
    Button,
    IconButton,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    Snackbar,
    Alert,
    TextField,
    MenuItem,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { showToast } from "../Components/PopupMessage.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar, PickersDay } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";

import { useContext } from "react";
import { BookmarkedContext } from "../Context/BookmarkedContext.jsx";
import { se } from "date-fns/locale";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CIcon from '@coreui/icons-react';
import { cilClock } from '@coreui/icons';


function SafeComponent({ html }) {
    const cleanHTML = DOMPurify.sanitize(html);
    return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
}

const CustomDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== "isAvailable" && prop !== "isSelected",
})(({ theme, isAvailable, isSelected }) => ({
    borderRadius: "50%",

    ...(isAvailable && {
        "&::after": {
            content: '""',
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: "green",
            position: "absolute",
            bottom: 4,
        },
    }),

    ...(isSelected && {
        backgroundColor: "green !important",
        color: "white !important",
    }),
}));





function PackageTourDetails() {
    const { slugId } = useParams();
       const parts = slugId.split("-");
    
    const random = parseInt(parts.pop());
    const encodedId = parseInt(parts.pop());
    const id = encodedId - random;


    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(null);
    const [tourData, setTourData] = useState({});
    const [tourPriceData, setTourPriceData] = useState({});
    const [activities, setActivities] = useState([]);
    const [tourImages, setTourImages] = useState([]);
    const [tourVideos, setTourVideos] = useState([]);
    const [itininerary, setItinerary] = useState([]);
    const [showPrice, setShowPrice] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const accessToken = localStorage.getItem("accessToken");
    const customer_data = JSON.parse(localStorage.getItem("customer"));
    const [tourOnlyPrice, setTourOnlyPrice] = useState(0);
    const [groupDepartureDates, setGroupDepartureDates] = useState([]);
    const [packageType, setPackageType] = useState("basic");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [travellers, setTravellers] = useState([{ name: "", age: "", type: "adult" }]);
    const { addBookmark, removeBookmark, isBookmarked, bookmarkedItems } = useContext(BookmarkedContext);
    const [selectedDate, setSelectedDate] = useState(null);
    const availableDates = tourData?.dates?.group?.departure_dates || [];
    const [transportData, setTransportData] = useState([]);
    const [showAll, setShowAll] = useState(false);
    // MODAL FOR PASSENGER DETAILS
    const [openPassengerModal, setOpenPassengerModal] = useState(false);

    // Store Passenger Details Dynamically
    const [passengerDetails, setPassengerDetails] = useState([]);



    // Package Type: Basic / Standard / Premium
    const [selectedPackage, setSelectedPackage] = useState("Basic");

    // Travellers
    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [infants, setInfants] = useState(0);

    // Calculated Price
    const [finalPrice, setFinalPrice] = useState(0);
    const [selectedHotelPrices, setSelectedHotelPrices] = useState([]);
    const [selectedTransport, setSelectedTransport] = useState(null);
    const [showMoreDesc, setShowMoreDesc] = useState(false);

    // Extra pricing (default 0 until added)
    const [adultExtra, setAdultExtra] = useState(0);
    const [childExtra, setChildExtra] = useState(0);
    const [infantExtra, setInfantExtra] = useState(0);
    const [hotelId, setHotelId] = useState(null);
    const [roomId, setRoomlId] = useState(null);
    const [transportId, setTransportId] = useState(null);
    const [personPrice, setPerPersonPrice] = useState(0);
    const [nRooms, setNRooms] = useState(1);
    const activitySectionRef = useRef(null);
    const [activityPrice, setActivityPrice] = useState(0);
    const [total_amount, setTotal_amount] = useState(0);




    const toggleDay = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };






    function calculateNights(checkIn, checkOut) {
        if (!checkIn || !checkOut) return 0;
        const inDate = new Date(checkIn);
        const outDate = new Date(checkOut);
        const diffTime = outDate.getTime() - inDate.getTime();
        const nights = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        return nights + 1;
    }



    useEffect(() => {
        const handleTourOverview = async () => {
            try {
                const response = await api.get(`/tours/${id}/details`);
                if (response?.data?.success === true) {
                    setItinerary(response?.data?.data?.itineraries || []);
                    setTourData(response?.data?.data?.tour);
                    setTourPriceData(response?.data?.data);
                    setAdultExtra(response?.data?.data?.computed_totals?.adult_extra || 0);
                    setChildExtra(response?.data?.data?.computed_totals?.child_extra || 0);
                    setInfantExtra(response?.data?.data?.computed_totals?.infant_extra || 0);
                    setActivities(response?.data?.data?.tour?.activities || []);
                    setPerPersonPrice(response?.data?.data?.tour?.raw_columns?.mrp_basic || 0);
                    setTotalPrice(
                        response?.data?.data?.tour?.pricing?.stored_totals?.total_price_basic || tourData?.pricing?.per_person?.adult
                    );
                    setTourImages(response?.data?.data?.photos || []);
                    setTourVideos(response?.data?.data?.videos?.[0] || []);
                }
            } catch (error) {
                console.error("Error fetching tour data: ", error);
            }
        };
        handleTourOverview();
    }, [id]);


    // const calculateTotalPrice = () => {
    //     const raw = tourPriceData?.tour?.raw_columns;
    //     if (!raw) return;
    //     let finalTotal = 0;


    //     const totalPeople = adults + children;
    //     if(selectedPackage==="Basic"){
    //         finalTotal = raw.mrp_basic * totalPeople;
    //         setPerPersonPrice(raw.mrp_basic);

    //     }else if(selectedPackage==="Standard"){
    //         finalTotal = raw.mrp_standard * totalPeople;
    //         setPerPersonPrice(raw.mrp_standard);

    //     }else{
    //         finalTotal = raw.mrp_premium * totalPeople;
    //         setPerPersonPrice(raw.mrp_premium);

    //     }


    //     setFinalPrice(finalTotal);


    // };

    const calculateTotalPrice = () => {
        if (!tourPriceData?.displays) return;

        const totalPeople = adults + children;
        if (tourData?.counts?.total_seat < totalPeople) {
            showToast(`Maximum seat is ${tourData?.counts?.total_seat}`, "error");
            return;
        }
        const hotelData =
            tourPriceData.tour?.raw_columns?.hotel_data_raw[selectedPackage];

        let total = 0;

        /** ======================================================
         *  1️⃣ HOTEL PRICE + ROOM VALIDATION + SMART TRIPLE LOGIC
         * ====================================================== */

const getHotelPrice = () => {
    if (!hotelData) return 0;

    const maxCapacity = nRooms * 3;

    if (totalPeople > maxCapacity) {
        showToast("Please add more rooms (max 3 persons per room)", "error");
        return null;
    }

    let totalPrice = 0;
    let breakdown = [];

    Object.values(hotelData).forEach(day => {
        const base = Number(day.base_price);
        const tripleAdult = Number(day.adult_extra_price);
        const tripleChild = Number(day.child_extra_price);

        // ✅ Base price per room
        let dayPrice = nRooms * base;

        const baseCapacity = nRooms * 2;
        const extraCapacity = nRooms; // 1 extra per room

        const extraPeople = Math.max(0, totalPeople - baseCapacity);
        const allowedExtra = Math.min(extraPeople, extraCapacity);

        let remainingExtraSlots = allowedExtra;

        // 🔥 Child extra applied first
        const childExtraCount = Math.min(children, remainingExtraSlots);
        dayPrice += childExtraCount * tripleChild;
        remainingExtraSlots -= childExtraCount;

        // 🔥 Then adult extra
        const adultExtraCount = Math.min(adults, remainingExtraSlots);
        dayPrice += adultExtraCount * tripleAdult;

        totalPrice += dayPrice;

        breakdown.push({
            hotel_id: day.hotel_id,
            room_id: day.room_id,
            price: dayPrice
        });
    });
    console.log("Hotel Breakdown:", breakdown);

    return totalPrice;
};

        const hotelPrice = getHotelPrice();
        if (hotelPrice === null) return;

        console.log("Hotel Price:", hotelPrice);


        /** ======================================================
         *  TRANSPORT SELECTION BASED ON TOTAL SEATS REQUIRED
         * ====================================================== */



        const transportGroup =
            tourPriceData.tour?.raw_columns?.transport_data_raw?.[selectedPackage];

        let selectedTransport = [];
        let transportIds = [];
        let transportCost = 0;

        Object.keys(transportGroup || {}).forEach(dayKey => {
            const vehicles = transportGroup[dayKey] || [];

            // filter suitable vehicle by capacity
            const validOptions = vehicles
                .filter(v => Number(v.capacity) >= totalPeople)
                .sort((a, b) => a.capacity - b.capacity);

            if (validOptions.length > 0) {
                const bestVehicle = validOptions[0];

                selectedTransport.push({
                    day: Number(dayKey),
                    ...bestVehicle,
                });
                console.log("Selected Vehicle for Day ", dayKey, ": ", bestVehicle);

                transportIds.push(bestVehicle.transport_id);

                // ✔ per-head price per day
                transportCost += Number(bestVehicle.base_price) / Number(bestVehicle.capacity);
            }
        });

        setSelectedTransport(selectedTransport);
        setTransportId(transportIds);
        // final per-person transport price for whole trip
        // setTransportPrice(Number(transportCost.toFixed(2)));

        console.log("the transport cost is", transportCost);        






        /** ======================================================
         *  5️⃣ EXTRAS
         * ====================================================== */

        const extraTotal =
            adults * adultExtra / Number(tourData?.counts?.total_seat) +
            children * childExtra
          


        /** ======================================================
         *  6️⃣ FINAL TOTAL
         * ====================================================== */

// apatoto extra price add kora nei

        const activityTotal = calculateActivityTotal();
        setActivityPrice(activityTotal);

        total = hotelPrice + Number(transportCost.toFixed(2)) * totalPeople + activityTotal + extraTotal;

        setFinalPrice(total);
    };



    const calculateTotalPrices = () => {
        if (!tourPriceData?.displays) return;

        const totalPeople = adults + children;
        if (tourData?.counts?.total_seat < totalPeople) {
            showToast(`Maximum seat is ${tourData?.counts?.total_seat}`, "error");
            return;
        }
        const hotelData =
            tourPriceData.tour?.raw_columns?.hotel_data_raw[selectedPackage];

        let total = 0;

        /** ======================================================
         *  1️⃣ HOTEL PRICE + ROOM VALIDATION + SMART TRIPLE LOGIC
         * ====================================================== */

const getHotelPrice = () => {
    if (!hotelData) return 0;

    const maxCapacity = nRooms * 3;

    if (totalPeople > maxCapacity) {
        showToast("Please add more rooms (max 3 persons per room)", "error");
        return null;
    }

    let totalPrice = 0;
    let breakdown = [];

    Object.values(hotelData).forEach(day => {
        const base = Number(day.base_price);
        const tripleAdult = Number(day.adult_extra_price);
        const tripleChild = Number(day.child_extra_price);

        // ✅ Base price per room
        let dayPrice = nRooms * base;

        const baseCapacity = nRooms * 2;
        const extraCapacity = nRooms; // 1 extra per room

        const extraPeople = Math.max(0, totalPeople - baseCapacity);
        const allowedExtra = Math.min(extraPeople, extraCapacity);

        let remainingExtraSlots = allowedExtra;

        // 🔥 Child extra applied first
        const childExtraCount = Math.min(children, remainingExtraSlots);
        dayPrice += childExtraCount * tripleChild;
        remainingExtraSlots -= childExtraCount;

        // 🔥 Then adult extra
        const adultExtraCount = Math.min(adults, remainingExtraSlots);
        dayPrice += adultExtraCount * tripleAdult;

        totalPrice += dayPrice;

        breakdown.push({
            hotel_id: day.hotel_id,
            room_id: day.room_id,
            price: dayPrice
        });
    });

    return totalPrice;
};

        const hotelPrice = getHotelPrice();
        if (hotelPrice === null) return;

        console.log("Hotel Price:", hotelPrice);


        /** ======================================================
         *  TRANSPORT SELECTION BASED ON TOTAL SEATS REQUIRED
         * ====================================================== */



        const transportGroup =
            tourPriceData.tour?.raw_columns?.transport_data_raw?.[selectedPackage];

        let selectedTransport = [];
        let transportIds = [];
        let transportCost = 0;

        Object.keys(transportGroup || {}).forEach(dayKey => {
            const vehicles = transportGroup[dayKey] || [];

            // filter suitable vehicle by capacity
            const validOptions = vehicles
                .filter(v => Number(v.capacity) >= totalPeople)
                .sort((a, b) => a.capacity - b.capacity);

            if (validOptions.length > 0) {
                const bestVehicle = validOptions[0];

                selectedTransport.push({
                    day: Number(dayKey),
                    ...bestVehicle,
                });

                transportIds.push(bestVehicle.transport_id);

                // ✔ per-head price per day
                transportCost += Number(bestVehicle.base_price) / Number(bestVehicle.capacity);
            }
        });

        setSelectedTransport(selectedTransport);
        setTransportId(transportIds);
        // final per-person transport price for whole trip
        // setTransportPrice(Number(transportCost.toFixed(2)));
        console.log("the transport cost is", transportCost);








        /** ======================================================
         *  5️⃣ EXTRAS
         * ====================================================== */

        const extraTotal =
            adults * adultExtra / Number(tourData?.counts?.total_seat)

console.log("Extras Total: ", extraTotal);
        /** ======================================================
         *  6️⃣ FINAL TOTAL
         * ====================================================== */


        total = hotelPrice + Number(transportCost.toFixed(2)) * totalPeople + extraTotal;


        setTotal_amount(total);
    };


    useEffect(() => {
        if (tourPriceData?.tour?.raw_columns?.hotel_data_raw) {
            calculateTotalPrices();
        }
    }, [selectedPackage,tourData,tourPriceData]);

    const updatePassenger = (index, field, value) => {
        const updated = [...passengerDetails];
        updated[index][field] = value;
        setPassengerDetails(updated);
    };


    useEffect(() => {
        calculateTotalPrice();
    }, [adults, children, infants, selectedPackage, tourData, nRooms,tourPriceData,activityPrice]);



    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "none", background: "red" }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "none", background: "green" }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        customPaging: function (i) {
            return (
                <a>
                    <img
                        src={tourData?.images[i]?.url}
                        alt={`thumb-${i}`}
                        className="carousel-thumbnail"
                    />
                </a>
            );
        },
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        fade: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };

    const handleConfirmBooking = async () => {
        if (!accessToken) {
            showToast("please Login to book Tour", "error")
            navigate("/signup")
            return
        }
        if (!selectedDate) {
            showToast("Please select a start date", "error");
            return;
        }

        // Validate passenger details
        for (let p of passengerDetails) {
            if (!p.name || !p.age || !p.type || !p.email || !p.phone) {
                showToast("Please fill all passenger details", "error");
                return;
            }
        }
        const totalPassenger = adults + children + infants
        if (totalPassenger > Number(tourData?.counts?.total_seat)) {
            showToast(`Maximum seat is ${tourData?.counts?.total_seat}`, "error");
            return;
        }

        const Activities = getSelectedActivitiesPayload();
        const endDate = dayjs(selectedDate).add(tourData.raw_columns.no_of_days, "day").format("YYYY-MM-DD");
        console.log("end date", endDate);
        const payload = {
            tour_id: id,
            customer_id: customer_data?.id,
            meta: {
                package_type: selectedPackage
            },
            start_date: selectedDate?.format("YYYY-MM-DD"),
            adult_count: adults,
            child_count: children,
            infant_count: infants,
            total_amount: finalPrice,
            passengers: passengerDetails,
            transport_id: transportId,
            hotel_id: hotelId,
            room_id: roomId,
            breakfast: null,
            lunch: null,
            dinner: null,
            no_of_room: selectedHotelPrices.reduce((sum, h) => sum + h.rooms, 0) || 1,
            tour_start_date: selectedDate?.format("YYYY-MM-DD"),
            tour_end_date: endDate,
            group_departure_dates_input: [selectedDate?.format("YYYY-MM-DD")],
            activities: Activities,
        };
        console.log("Booking Payload:", payload);
        try {
            setLoading(true);

            const response = await api.post("/bookings/tour", payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            console.log("Booking Response:", response.data);

            if (response.data.status === true) {
                showToast("Booking Successful!", "success");
                setOpenPassengerModal(false);

                navigate(`/tour-review/${slugId}`, {
                    state: { bookingDetails: response?.data?.data },
                });
            } else {
                showToast(response.data.message || "Booking failed", "error");
            }
        } catch (error) {
            console.error(error);
            showToast("Server error while booking", "error");
        } finally {
            setLoading(false);
        }
    };


    const groupedDepartures = {};

    availableDates.forEach((d) => {
        const date = dayjs(d);
        const year = date.format("YYYY");
        const month = date.format("MMM");

        if (!groupedDepartures[year]) groupedDepartures[year] = {};
        if (!groupedDepartures[year][month]) groupedDepartures[year][month] = [];

        groupedDepartures[year][month].push(d);
    });





    const activitySlider = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 3,       // default for large screens
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024, // <= 1024px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768, // <= 768px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const [seatCounts, setSeatCounts] = useState({});


    const calculateActivityTotal = () => {
        return activities.reduce((total, activity) => {
            const qty = seatCounts[activity.id] || 0;
            const price = Number(activity.price) || 0;
            return total + qty * price;
        }, 0);
    };
    const getSelectedActivitiesPayload = () => {
        return activities
            .filter(a => seatCounts[a.id] > 0)   // only selected ones
            .map(a => ({
                activity_id: a.id,
                quantity: seatCounts[a.id],
                price: Number(a.price)
            }));
    };




    const handleAddClick = (id) => {
        setSeatCounts((prev) => {
            const newCount = (prev[id] || 0) + 1;

            showToast(`Activity added (${newCount})`, "success");

            return {
                ...prev,
                [id]: newCount,
            };
        });
    };


    const handleRemoveClick = (id) => {
        setSeatCounts((prev) => {
            const currentCount = prev[id] || 0;
            const newCount = currentCount > 0 ? currentCount - 1 : 0;

            showToast(`Activity removed (Remain: ${newCount})`, "warn");

            return {
                ...prev,
                [id]: newCount,
            };
        });
    };
    useEffect(() => {
        calculateTotalPrice();
    }, [seatCounts]);


    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 300) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);



    return (
        <div style={{ fontFamily: " Quicksand, sans-serif" }}>
            <div style={{ backgroundColor: "#f0f0f0" }}>
                <Navber />
            </div>



            {/* --- MAIN CONTENT BELOW --- */}
            <div className="travel-card">
                <div className="travel-card-image">
                    <Slider {...settings}>
                        {tourData?.images?.map((imgSrc, index) => (
                            <div key={index}>
                                <img src={imgSrc?.url} alt={`tour-${index}`} className="travel-card-image_img" />
                            </div>
                        ))}
                    </Slider>

                    <h3 style={{ marginTop: "30px", fontSize: "2rem" }}>Services</h3>
                    <div
                        style={{ display: "flex", justifyContent: "center" }}
                        className="service_icons"
                    >
                        {[{ img: Building, label: "Hotel" },
                        { img: Van, label: "Transport" },
                        { img: Cablecar, label: "Activity" },
                        { img: NavigationArrow, label: "Itinerary" }].map((item, i) => (
                            <span
                                key={i}
                                style={{
                                    width: "70px",
                                    height: "70px",
                                    borderRadius: "50%",
                                    padding: "20px",
                                    backgroundColor: "black",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                    alignItems: "center",
                                    fontWeight: "600",
                                    color: "white",
                                }}
                            >
                                <img src={item.img} height="100%" width="100%" />
                                <span>{item.label}</span>
                            </span>
                        ))}
                    </div>

                    <div className="action-buttons-container">

                        {/* BOOK NOW BUTTON */}
                        <button
                            className="action-btn action-btn-book"
                            onClick={() => {
                                const totalTravellers = adults + children + infants;

                                setPassengerDetails(
                                    Array.from({ length: totalTravellers }, () => ({
                                        name: "",
                                        email: "",
                                        phone: "",
                                        age: "",
                                        type: "adult",
                                    }))
                                );

                                setOpenPassengerModal(true);
                            }}
                        >
                            Book Now
                        </button>

                        {/* BOOKMARK BUTTON */}
                        <button
                            className="action-btn action-btn-bookmark"
                            onClick={() => {
                                isBookmarked(tourData?.id)
                                    ? removeBookmark(tourData?.id)
                                    : addBookmark({
                                        ...tourData,
                                        finalPrice: finalPrice
                                    });
                            }}
                        >
                            {isBookmarked(tourData?.id) ? "Bookmarked" : "Add to Bookmark"}
                        </button>

                    </div>







                </div>

                {/* RIGHT CONTENT */}
                <div className="travel-card-content">
                    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                        <h3 className="travel-title">{tourData?.title}</h3>
                        <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                            <h3 className="travel-price">₹{total_amount}/person</h3>
                        </div>

                    </div>
                    <div>
                        {/* Only 3 lines when collapsed */}
                        <div className={!showMoreDesc ? "description-clamp" : ""}>
                            {tourData?.raw_columns?.overview &&
                                <p><strong>Overview: </strong>{tourData?.raw_columns?.overview}</p>}
                            <SafeComponent html={tourData?.raw_columns?.description} />
                        </div>

                        {/* Toggle Button */}
                        {tourData?.description && (
                            <span
                                className="show-toggle"
                                onClick={() => setShowMoreDesc(!showMoreDesc)}
                            >
                                {showMoreDesc ? "Show Less" : "Show More..."}
                            </span>
                        )}
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: "2px", alignItems: "center", width: "100%" }}>
                        <div style={{ width: "100%" }}>Total Seats: {tourData?.counts?.total_seat}</div>
                        <div className="travel-info-left" style={{ width: "100%" }}>
                            <CIcon icon={cilClock} width="15px" />
                            <span>
                                {tourData?.no_of_days || "0"} days
                            </span>
                        </div>
                    </div>


                    {/* Package Section */}
                    <div className="package_activity">
                        <div className="package-section">
                            <h3 className="package-title">Select Package Type</h3>

                            <div className="package-options">
                                {["Basic", "Standard", "Premium"].map((pkg) => (
                                    <label key={pkg} className="package-option">
                                        <input
                                            type="radio"
                                            name="packageType"
                                            value={pkg}
                                            checked={selectedPackage === pkg}
                                            onChange={(e) => setSelectedPackage(e.target.value)}
                                        />
                                        {pkg}
                                    </label>
                                ))}
                            </div>


                        </div>
                        <div>
                            {activities.length > 0 && <button
                                className="action-btns"
                                onClick={() => {
                                    activitySectionRef.current?.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start"
                                    });
                                }}
                            >
                                +Add Activities
                            </button>}
                        </div>
                    </div>

                    {/* TOUR START DATE */}
                    <div className="tour-date-section" style={{ width: "100%" }}>
                        <div style={{ display: 'flex', justifyContent: "space-between", flexDirection: "column", width: "100%" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", alignItems: "center" }}>
                                <div className="traveller-title">
                                    Select Start Date:{" "}
                                    {selectedDate ? selectedDate.format("DD MMM YYYY") : "Not Selected"}
                                </div>
                                {/* <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "green" }}>Payable Price: ₹{finalPrice}</div> */}
                            </div>


                            <div className="departure-container">

                                {Object.keys(groupedDepartures).map((year) => (
                                    <div key={year} className="departure-year-block">

                                        <div className="departure-year-label">Y {year}</div>

                                        {Object.keys(groupedDepartures[year]).map((month) => (
                                            <div key={month} className="departure-month-block">

                                                <div className="departure-month-label">{month}</div>

                                                <div className="departure-dates-grid">
                                                    {groupedDepartures[year][month].map((date, index) => {
                                                        const dateObj = dayjs(date);
                                                        const isActive =
                                                            selectedDate &&
                                                            selectedDate.format("YYYY-MM-DD") === dateObj.format("YYYY-MM-DD");

                                                        return (
                                                            <button
                                                                key={index}
                                                                className={`departure-date-btn ${isActive ? "active" : ""}`}
                                                                onClick={() => setSelectedDate(dateObj)}
                                                            >
                                                                {dateObj.format("D")}
                                                            </button>
                                                        );
                                                    })}
                                                </div>

                                            </div>
                                        ))}

                                    </div>
                                ))}

                            </div>
                        </div>







                    </div>
                    {tourPriceData?.hotels?.length > 0 && (
                        <div>
                            <h3 className="traveller-title">Choose Rooms (Max 1 room for triple sharing)</h3>
                            <FormControl fullWidth>
                                <InputLabel>Duplex Room</InputLabel>
                                <Select
                                    value={nRooms}
                                    label="No.of Rooms"
                                    onChange={(e) => setNRooms(Number(e.target.value))}
                                >
                                    {[...Array(20)].map((_, i) => (
                                        <MenuItem key={i + 1} value={i + 1}>
                                            {i + 1}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    )}
                    {/* TRAVELLER INPUTS */}
                    <div className="traveller-section">
                        <div style={{ fontSize: "1.2rem", fontWeight: "700", color: "green" }}>Total Amount: ₹{finalPrice.toFixed(2)}/person</div>
                        <h3 className="traveller-title">Travellers</h3>

                        <div className="traveller-flex">
                            {/* Adults */}
                            <FormControl fullWidth>
                                <InputLabel>Person (4yrs+)</InputLabel>
                                <Select
                                    value={adults}
                                    label="Person (4yrs+)"
                                    onChange={(e) => setAdults(Number(e.target.value))}
                                >
                                    {[...Array(50)].map((_, i) => (
                                        <MenuItem key={i + 1} value={i + 1}>
                                            {i + 1}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Children */}
                            <FormControl fullWidth>
                                <InputLabel>Child (0-4yrs)</InputLabel>
                                <Select
                                    value={children}
                                    label="Child (0-4yrs)"
                                    onChange={(e) => setChildren(Number(e.target.value))}
                                >
                                    {[...Array(21)].map((_, i) => (
                                        <MenuItem key={i} value={i}>
                                            {i}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>


                    {/* Itinerary Accordion */}
                    <div
                        style={{
                            width: "100%",
                            fontFamily: "Quicksand, sans-serif",
                            backgroundColor: "#ffff",
                            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            margin: "auto",
                            padding: "5%",
                            borderRadius: "10px",
                        }}
                    >
                        <h2 style={{ textAlign: "center", marginBottom: "1rem", fontFamily: "Gill Sans, sans-serif", fontSize: "1.5rem" }}>
                            Day Wise <strong>Itinerary</strong>
                        </h2>

                        {itininerary?.map((day, index) => (
                            <Accordion key={index} defaultExpanded sx={{ marginBottom: "10px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;" }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel-${index}-content`}
                                    id={`panel-${index}-header`}
                                >
                                    <Typography fontWeight="bold">
                                        DAY {index + 1} – {day?.name}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                                        {day.description
                                            ?.replace(/&nbsp;/gi, " ")          // remove &nbsp;
                                            ?.replace(/&ndash;/gi, " ")          // remove &nbsp;
                                            ?.replace(/&amp; /gi, " ")          // remove &nbsp;
                                            ?.replace(/<\/?p>/g, "\n")          // replace <p> with new line
                                            ?.replace(/<br\s*\/?>/gi, "\n")     // handle <br> tags
                                            ?.replace(/<[^>]+>/g, "")           // remove all other HTML tags
                                            // ?.replace(/\s+/g, " ")              
                                            ?.split("\n")
                                            ?.map(line => line.trim())
                                            ?.filter(line => line !== "")
                                            ?.map((line, i) => (
                                                <li key={i} style={{ marginBottom: "8px" }}>
                                                    {line}
                                                </li>
                                            ))}
                                    </ul>

                                    {/* Optional Meal Info */}

                                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                                        {day?.breakfast && <span>🍽️ Breakfast</span>}
                                        {day?.lunch && <span>🍽️ Lunch</span>}
                                        {day?.dinner && <span>🍽️ Dinner</span>}
                                    </div>

                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>

                    {/* Map */}
                    <div
                        style={{
                            width: "100%",
                            margin: "0 auto",
                            borderRadius: "12px",
                            overflow: "hidden",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                        }}
                    >
                        <h3 style={{ padding: "4px" }}>View In map</h3>
                        <SafeMap mapHtml={tourData?.destination?.map} />
                    </div>
                </div>
            </div>

            {/* Activities */}
            <div className="activity-slider-container" ref={activitySectionRef}>
                <h3 className="activity-slider-title">{activities.length > 0 && "Add Popular Activities"}</h3>

                <Slider {...activitySlider}>
                    {activities.map((activity) => (
                        <div className="activity-card" key={activity.id}>
                            <div className="activity-card-img-wrapper">
                                <img
                                    src={activity.image_url}
                                    alt={activity.name}
                                    className="activity-card-img"
                                />
                                <div className="activity-card-overlay">
                                    <h3 className="activity-card-name">{activity.name}</h3>
                                    <p className="activity-card-price">₹{activity.price}</p>
                                </div>
                            </div>

                            <div className="activity-card-footer">
                                {seatCounts[activity.id] > 0 ? (
                                    <div className="seat-counter">
                                        <button
                                            className="seat-btn"
                                            onClick={() => handleRemoveClick(activity.id)}
                                        >
                                            –
                                        </button>
                                        <span>{seatCounts[activity.id]}</span>
                                        <button
                                            className="seat-btn"
                                            onClick={() => handleAddClick(activity.id)}
                                        >
                                            +
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        className="activity-add-btn"
                                        onClick={() => handleAddClick(activity.id)}
                                    >
                                        Add
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* <Travelers_favorite /> */}
            <User_Destinations />
            <div className="terms_and_condition">
                <h4 style={{ textDecoration: "underline" }}>Terms and Condition : </h4>
                <SafeComponent html={tourData?.raw_columns?.terms_conditions} />
            </div>

            <Why_travel_with_us />
            <Typemsg />




            <Modal
                open={openPassengerModal}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setOpenPassengerModal(false);
                    }
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{ timeout: 500 }}
            >
                <Fade in={openPassengerModal}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: { xs: "90%", sm: "450px" },
                            maxHeight: "85vh",
                            overflowY: "auto",
                            bgcolor: "background.paper",
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 3,
                            "&::-webkit-scrollbar": { width: "6px" },
                            "&::-webkit-scrollbar-track": { background: "#f0f0f0", borderRadius: "10px" },
                            "&::-webkit-scrollbar-thumb": { background: "#b5b5b5", borderRadius: "10px" },
                            "&::-webkit-scrollbar-thumb:hover": { background: "#9e9e9e" },
                        }}
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6">Confirm Booking Details</Typography>
                            <IconButton onClick={() => setOpenPassengerModal(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Box sx={{ mt: 2, p: 2, border: "1px solid #ccc", borderRadius: 1 }}>
                            <Typography variant="subtitle1"><b>Package:</b> {selectedPackage}</Typography>
                            <Typography variant="subtitle1"><b>Start Date:</b> {selectedDate?.format("DD/MM/YYYY")}</Typography>
                            <Typography variant="subtitle1">
                                <b>Travellers:</b> {adults} Adults, {children} Children
                            </Typography>
                            <Typography variant="subtitle1"><b>Activity Price:</b> ₹{activityPrice}</Typography>
                            <Typography variant="subtitle1"><b>Total Price:</b> ₹{finalPrice}</Typography>
                        </Box>

                        <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>
                            Passenger Details
                        </Typography>

                        {passengerDetails.map((p, index) => (
                            <Box key={index} sx={{ mb: 2, borderBottom: "1px solid #ddd", pb: 2 }}>
                                <Typography sx={{ mb: 1 }}>Passenger {index + 1}</Typography>

                                <TextField
                                    fullWidth
                                    label="Name"
                                    value={p.name}
                                    onChange={(e) => updatePassenger(index, "name", e.target.value)}
                                    sx={{ mb: 2 }}
                                />
                                <TextField
                                    fullWidth
                                    label="Email Address"
                                    type="email"
                                    required={index === 0}   // ✅ Required only for first passenger
                                    value={p.email || ""}
                                    onChange={(e) => {
                                        updatePassenger(index, "email", e.target.value);
                                    }}
                                    error={
                                        index === 0 &&
                                        (!p.email ||
                                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(p.email))
                                    }
                                    helperText={
                                        index === 0 &&
                                            (!p.email ||
                                                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(p.email))
                                            ? "Valid email address is required"
                                            : ""
                                    }
                                    sx={{ mb: 2 }}
                                />
                                <TextField
                                    fullWidth
                                    label="Phone Number"
                                    type="tel"
                                    required={index === 0}   // ✅ Required only for first passenger
                                    value={p.phone || ""}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, "");
                                        if (value.length <= 10) {
                                            updatePassenger(index, "phone", value);
                                        }
                                    }}
                                    inputProps={{
                                        maxLength: 10,
                                        inputMode: "numeric",
                                        pattern: "[0-9]*",
                                    }}
                                    error={index === 0 && (!p.phone || p.phone.length !== 10)}
                                    helperText={
                                        index === 0 && (!p.phone || p.phone.length !== 10)
                                            ? "Phone number is required and must be 10 digits"
                                            : ""
                                    }
                                    sx={{ mb: 2 }}
                                />

                                <TextField
                                    fullWidth
                                    label="Age"
                                    type="number"
                                    value={p.age}
                                    onChange={(e) => updatePassenger(index, "age", e.target.value)}
                                    sx={{ mb: 2 }}
                                />

                                <FormControl fullWidth>
                                    <InputLabel>Type</InputLabel>
                                    <Select
                                        value={p.type}
                                        label="Type"
                                        onChange={(e) => updatePassenger(index, "type", e.target.value)}
                                    >
                                        <MenuItem value="adult">Adult</MenuItem>
                                        <MenuItem value="child">Child</MenuItem>
                                        {/* <MenuItem value="infant">Infant</MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Box>
                        ))}

                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ mt: 2 }}
                            onClick={handleConfirmBooking}
                        >
                            Confirm Booking
                        </Button>

                    </Box>
                </Fade>
            </Modal>



            {showTopBtn && (
                <button
                    className="scrollTopBtn"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                    ↑
                </button>
            )}
        </div>
    )
}

export default PackageTourDetails